import React from 'react'
import type { Icon } from 'shared/utils'
import { COLOR } from 'app-v2/design-tokens'

export const CreditCard = ({
    color = COLOR.PRIMARY,
    size = 24,
    className = 'credit-card',
    ...otherProps
}: Icon) => (
    <svg
        width={size}
        height={(size / 17) * 12}
        viewBox="0 0 17 12"
        fill={color}
        className={className}
        {...otherProps}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.333 2H0.333008V1.25C0.333008 0.56 0.781008 0 1.33301 0H15.333C15.885 0 16.333 0.56 16.333 1.25V2ZM16.333 4.5V11C16.333 11.2652 16.2277 11.5196 16.0401 11.7071C15.8526 11.8946 15.5982 12 15.333 12H1.33301C1.06779 12 0.813437 11.8946 0.625901 11.7071C0.438365 11.5196 0.333008 11.2652 0.333008 11V4.5H16.333ZM4.33301 8C4.06779 8 3.81344 8.10536 3.6259 8.29289C3.43836 8.48043 3.33301 8.73478 3.33301 9C3.33301 9.26522 3.43836 9.51957 3.6259 9.70711C3.81344 9.89464 4.06779 10 4.33301 10H5.33301C5.59822 10 5.85258 9.89464 6.04011 9.70711C6.22765 9.51957 6.33301 9.26522 6.33301 9C6.33301 8.73478 6.22765 8.48043 6.04011 8.29289C5.85258 8.10536 5.59822 8 5.33301 8H4.33301Z"
            fill="#502314"
        />
    </svg>
)
